import { styled } from '@linaria/react';
import { ActionIcon, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Icon } from '../../../../ui-library/icon/icon';
import { getMentionTypeColor, getMentionTypeLabel } from './flora-mention.helpers';
import { CATEGORY_ICONS, type MentionItem } from './flora-mention.type';

interface MentionPillProps {
  mention: MentionItem;
  onRemove?: () => void;
  readonly?: boolean;
}

export const MentionPill = ({ mention, onRemove, readonly = false }: MentionPillProps) => {
  const { t } = useTranslation();
  const color = getMentionTypeColor(mention.type);

  return (
    <PillContainer style={{ backgroundColor: `${color}15`, borderColor: `${color}40` }}>
      <Icon name={CATEGORY_ICONS[mention.type]} color={color} size={14} style={{ flexShrink: 0 }} />
      <PillContent>
        <Text size="xs" fw={500} c={color} lineClamp={1}>
          {mention.name}
        </Text>
        <Text size="xs" c="dimmed" style={{ fontSize: 10 }}>
          {getMentionTypeLabel(mention.type, t)}
        </Text>
      </PillContent>
      {!readonly && onRemove && (
        <RemoveButton size="xs" variant="subtle" onClick={onRemove}>
          <Icon name="close" size={12} style={{ cursor: 'pointer' }} />
        </RemoveButton>
      )}
    </PillContainer>
  );
};

const PillContainer = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 16px;
  border: 1px solid;
  background: var(--base-white);
  max-width: 200px;
`;

const PillContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  min-width: 0;
  line-height: 1.2;
`;

const RemoveButton = styled(ActionIcon)`
  width: 16px;
  height: 16px;
  min-width: 16px;
  min-height: 16px;
  color: var(--ink-lighter, #999);
  flex-shrink: 0;

  &:hover {
    background: var(--flora-hover-subtle, rgba(0, 0, 0, 0.05));
  }
`;
